import { MTypography } from 'src/lib';
import { Color, Spacing } from 'src/styles';

import { BacklinkButton } from '../../../lib/Miscellaneous/BacklinkButton/BacklinkButton';
import Card from '../../../lib/Miscellaneous/Card';
import { Image } from '../../../styles';

import { customerAgreementLinks } from './constants';
import * as Styles from './CustomerAgreementReview.styles';

export const CustomerAgreementReview = () => {
  return (
    <div className={Styles.customerAgreementContainer}>
      <div className={Styles.top}>
        <BacklinkButton to={`/accounts/sign-application`} label='Return to My Account' />
        <img src={Image.Logo} alt='My IPO' className={Styles.logo} />
      </div>
      <div className={Styles.container}>
        <MTypography variant='h3' weight='semibold' color={Color.Brand6} className={Spacing.mb24}>
          Customer Agreement
        </MTypography>
        <MTypography variant='h6' color={Color.Gray8} align='center' className={Styles.subText}>
          Thank you for reviewing the customer agreements before completing the Account application
        </MTypography>
        <Card>
          <div className={Styles.certificationMain}>
            <div>
              {customerAgreementLinks.map(item => (
                <MTypography
                  key={`${item.label}_key`}
                  variant='body1'
                  color={Color.Brand6}
                  className={Styles.certificationLink}>
                  <a className={Styles.linkStyle} href={item.url} target='_blank' rel='noreferrer'>
                    {item.label}
                  </a>
                </MTypography>
              ))}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
